module.exports = __webpack_public_path__ + "img/km.5946bdc7.svg";